import React, { useEffect, useMemo, useState } from 'react';
import WhatsAppChat from '../../Components/WhatsAppChat/WhatsAppChat';
import imgMHSBrazil from '../../assets/BrazilServicos/HydraulicHoseCampaignSPABC/Hansa-Flex_27_02_2016-8263_Retusche.webp';
import imgSvcXCode from '../../assets/BrazilServicos/HydraulicHoseCampaignSPABC/Mangueiras.webp';
import imgProdHydraulics from '../../assets/BrazilServicos/HydraulicHoseCampaignSPABC/photo-1558618666-fcd25c85cd64.jpg';
import imgProdIndustrials from '../../assets/BrazilServicos/HydraulicHoseCampaignSPABC/photo-1504328345606-18bbc8c9d7d1.jpg';
import imgProdThermoplastics from '../../assets/BrazilServicos/HydraulicHoseCampaignSPABC/Services_Vorbeugende-Instandhaltung_07_1.webp';
import { useTranslation } from 'react-i18next';
import {
  CampaignPageLayout,
  CampaignHero,
  CampaignMarquee,
  CampaignStats,
  CampaignBenefits,
  CampaignServices,
  CampaignProducts,
  CampaignSectors,
  CampaignUrgency,
} from '../../Components/Campaign';

const accentFirstWord = (text) => {
  const spaceIndex = text.indexOf(' ');
  if (spaceIndex === -1) return text;
  return (
    <>
      <span>{text.slice(0, spaceIndex)}</span>
      {text.slice(spaceIndex)}
    </>
  );
};

const accentAfterConnector = (text) => {
  const match = text.match(/^(.+?)\s+(e|and)\s+(.+)$/i);
  if (!match) return accentFirstWord(text);
  return (
    <>
      {match[1]} {match[2]} <span>{match[3]}</span>
    </>
  );
};

const accentLastSegment = (text) => {
  const match = text.match(/^(.+?)\s+(para|for)\s+(.+)$/i);
  if (!match) return text;
  return (
    <>
      {match[1]} {match[2]} <span>{match[3]}</span>
    </>
  );
};

const accentLastWord = (text) => {
  const words = text.trim().split(/\s+/);
  if (words.length < 2) return text;
  const last = words.pop();
  return (
    <>
      {words.join(' ')} <span>{last}</span>
    </>
  );
};

const splitBulletLead = (text) => {
  const parts = text.split(' — ');
  if (parts.length < 2) return text;
  return (
    <>
      <strong>{parts[0]}</strong>
      {' — '}
      {parts.slice(1).join(' — ')}
    </>
  );
};

const getMobileServiceTabLabel = (t) => {
  const label = t('24-hour Mobile Service')
    .replace(/\s*24h\s*/gi, ' ')
    .replace(/24-hour\s*/gi, '')
    .trim();
  return `MHS — ${label}`;
};

const SEGMENT_ICON_ITEMS = [
  {
    key: 'Civil Construction',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
      </svg>
    ),
  },
  {
    key: 'Agribusiness',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    key: 'Metallurgy',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.07 4.93A10 10 0 115 18.36" />
      </svg>
    ),
  },
  {
    key: 'Automotive',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="1" y="3" width="15" height="13" rx="1" />
        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    ),
  },
  {
    key: 'Mining',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  },
  {
    key: 'Energy',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
      </svg>
    ),
  },
  {
    key: 'Petrochemical',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z" />
        <path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z" />
      </svg>
    ),
  },
  {
    key: 'General Maintenance',
    icon: (
      <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },
];

const HydraulicHoseCampaignSPABC = () => {
  const SOURCE = 'hydraulic-hose-campaign-sp-abc';
  const MAX_MESSAGE_LENGTH = 1000;
  const { t, i18n } = useTranslation();
  const isPortuguese = i18n.language === 'pt' || i18n.language?.startsWith('pt');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    fullName: '',
    company: '',
    email: '',
    telephone: '',
    cityState: '',
    message: '',
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const formatTelephone = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 10) return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  };

  const validateField = (name, value) => {
    const v = (value ?? '').toString();
    let error = '';

    switch (name) {
      case 'fullName':
        if (!v.trim()) error = 'Full name is required';
        break;
      case 'company':
        if (!v.trim()) error = 'Company is required';
        break;
      case 'email':
        if (!v.trim()) error = 'Email is required';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) error = 'Please enter a valid email address';
        break;
      case 'telephone':
        if (!v.trim()) error = 'Telephone is required';
        else if (v.replace(/\D/g, '').length < 10) error = 'Please enter a valid telephone number';
        break;
      case 'cityState':
        if (!v.trim()) error = 'Segment is required';
        break;
      case 'message':
        if (!v.trim()) error = 'Message is required';
        else if (v.trim().length < 10) error = 'Message must be at least 10 characters';
        else if (v.length > MAX_MESSAGE_LENGTH) error = `Message must not exceed ${MAX_MESSAGE_LENGTH} characters`;
        break;
      default:
        break;
    }

    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const processedValue = name === 'telephone' ? formatTelephone(value) : value;

    setFormData((prev) => ({ ...prev, [name]: processedValue }));
    if (touched[name]) {
      setErrors((prev) => ({ ...prev, [name]: validateField(name, processedValue) }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const validateForm = () => {
    const requiredFields = ['fullName', 'company', 'email', 'telephone', 'cityState', 'message'];
    const newErrors = {};
    const newTouched = {};

    requiredFields.forEach((key) => {
      newTouched[key] = true;
      const err = validateField(key, formData[key]);
      if (err) newErrors[key] = err;
    });

    setTouched((prev) => ({ ...prev, ...newTouched }));
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      fullName: '',
      company: '',
      email: '',
      telephone: '',
      cityState: '',
      message: '',
    });
    setTouched({});
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmitSuccess(false);
    setErrors((prev) => ({ ...prev, submit: '' }));

    try {
      const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.hansa-flex.co.in';
      const API_URL = `${API_BASE}/api/hf-brazil/contact/${SOURCE}`;
      const composedMessage = `Campaign: Hydraulic Hose SP/ABC\nCompany: ${formData.company}\nSegment: ${formData.cityState}\n\n${formData.message}`;

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: SOURCE,
          fullName: formData.fullName,
          company: formData.company,
          email: formData.email,
          telephone: formData.telephone,
          cityState: formData.cityState,
          cpfCnpj: '',
          message: composedMessage
        })
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Failed to send');

      setSubmitSuccess(true);
      setTimeout(() => {
        resetForm();
        setSubmitSuccess(false);
        setIsSubmitting(false);
      }, 5000);
    } catch (error) {
      setErrors((prev) => ({ ...prev, submit: error.message || 'Failed to send. Please try again later.' }));
      setIsSubmitting(false);
    }
  };

  const WHATSAPP_URL = 'https://wa.me/5511958139550';
  const WHATSAPP_EMERGENCY_URL = `https://wa.me/5511948062962?text=${encodeURIComponent(
    'Emergência: preciso de atendimento hidráulico urgente.'
  )}`;
  const PHONE_TEL = 'tel:+5511958139550';
  const PHONE_EMERGENCY_TEL = 'tel:+5511948062962';

  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const marqueeItems = useMemo(
    () => [
      t('Hydraulic Hoses'),
      t('São Paulo and ABC Paulista'),
      t('24-hour Mobile Service'),
      t('Over 80,000 Items'),
      t('ISO Certified'),
      t('X-CODE Manager'),
      t('On-site assembly'),
    ],
    [t, i18n.language]
  );

  const heroStats = useMemo(
    () => [
      { val: t('60+'), lbl: t('Years in the market') },
      { val: t('80K'), lbl: t('Items in catalog') },
      { val: t('6'), lbl: t('MHS Vehicles in Brazil') },
    ],
    [t, i18n.language]
  );

  const numerosStats = useMemo(
    () => [
      { val: t('60+'), lbl: t('Years of experience') },
      { val: t('80K'), lbl: t('Products in catalog') },
      { val: t('200'), lbl: t('MHS vehicles worldwide') },
    ],
    [t, i18n.language]
  );

  const servicosBlocks = useMemo(
    () => [
      {
        reverse: false,
        image: imgMHSBrazil,
        imageAlt: `${t('Mobile Hydraulic Service')} HANSA-FLEX`,
        tab: getMobileServiceTabLabel(t),
        num: t('01'),
        kicker: t('Emergency & Field'),
        title: accentFirstWord(t('Mobile Hydraulic Service')),
        paragraph: t(
          "Hydraulic failures don't give warning. Our mobile workshop comes to you — factory, construction site, or field — and manufactures the hose on-site."
        ),
        bullets: [
          splitBulletLead(t('6 vehicles in Brazil — coverage in São Paulo and ABC region.')),
          t('Hoses manufactured and assembled on site.'),
          t('24-hour emergency service'),
        ],
        cta: t('Trigger MHS'),
        revealClass: 'hhc-reveal-right',
      },
      {
        reverse: true,
        image: imgSvcXCode,
        imageAlt: `${t('X-CODE Manager')} HANSA-FLEX`,
        tab: t('X-CODE Manager'),
        num: t('02'),
        kicker: t('Intelligent management'),
        title: accentAfterConnector(t('Tracking and preventive maintenance')),
        paragraph: t(
          'Each hose receives a unique code. Through the My.HANSA-FLEX portal, you can monitor the entire hydraulic system and eliminate unexpected breakdowns.'
        ),
        bullets: [
          t('Individual identification of all hoses.'),
          t('Portal + app with automatic alerts'),
          t('Complete history for audit purposes.'),
        ],
        cta: t('Get to know X-CODE'),
        revealClass: 'hhc-reveal-left',
      },
    ],
    [t, i18n.language]
  );

  const produtosCards = useMemo(
    () => [
      {
        id: 'hydraulics',
        img: imgProdHydraulics,
        alt: t('High-pressure hydraulic hoses'),
        tag: t('High Pressure'),
        name: t('Hydraulics'),
      },
      {
        id: 'industrial',
        img: imgProdIndustrials,
        alt: t('Industrial hoses'),
        tag: t('Transfer'),
        name: t('Industrialists'),
      },
      {
        id: 'thermoplastic',
        img: imgProdThermoplastics,
        alt: t('Thermoplastic hoses'),
        tag: t('Thermoplastic'),
        name: t('Thermoplastics'),
      },
    ],
    [t, i18n.language]
  );

  const segmentosCards = useMemo(
    () =>
      SEGMENT_ICON_ITEMS.map(({ key, icon }) => ({
        id: key,
        name: t(key),
        icon,
      })),
    [t, i18n.language]
  );

  const beneficiosCards = useMemo(
    () => [
      {
        id: 'high-quality',
        title: t('High quality'),
        text: t(
          'ISO certification and materials meeting the highest international standards in every product.'
        ),
        icon: (
          <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        ),
      },
      {
        id: 'xcode-manager',
        title: t('X-CODE Manager'),
        text: t('Track every installed hose and reduce downtime with proactive alerts.'),
        icon: (
          <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
          </svg>
        ),
      },
      {
        id: 'mobile-service',
        title: t('24-hour Mobile Service'),
        text: t(
          'Mobile hydraulic workshop comes to your plant in São Paulo and ABC region. Hoses manufactured on-site.'
        ),
        icon: (
          <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="1" y="3" width="15" height="13" rx="1" />
            <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
            <circle cx="5.5" cy="18.5" r="2.5" />
            <circle cx="18.5" cy="18.5" r="2.5" />
          </svg>
        ),
      },
      {
        id: 'complete-catalog',
        title: t('Complete catalog'),
        text: t(
          'More than 80,000 items — hoses, fittings and accessories — available in real time.'
        ),
        icon: (
          <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3.01" y2="6" />
            <line x1="3" y1="12" x2="3.01" y2="12" />
            <line x1="3" y1="18" x2="3.01" y2="18" />
          </svg>
        ),
      },
    ],
    [t, i18n.language]
  );

  const coverageArea = t('São Paulo and ABC Paulista');
  const formQuoteTitle = accentLastWord(t('Get a quote'));

  const heroTitle = isPortuguese ? (
    <>
      Mangueiras
      <em>Hidráulicas</em>
      sob medida
    </>
  ) : (
    <>
      Hydraulics
      <em>Hoses</em>
      custom-made
    </>
  );

  return (
    <CampaignPageLayout>
      <CampaignHero
        backgroundImage={imgMHSBrazil}
        ariaLabel={`${t('Hydraulic Hoses')} SP & ABC`}
        imageAriaLabel={t('24-hour Mobile Service')}
        eyebrow={t('São Paulo & ABC Paulista')}
        title={heroTitle}
      subtitle={t(
        'Fast manufacturing, assembly, and delivery for your operation in São Paulo and ABC. 24/7 mobile service, X-CODE, and over 80,000 items available.'
      )}
      stats={heroStats}
      quoteLabel={t('Request a Quote')}
      whatsappLabel={t('WhatsApp')}
      callLabel={t('To connect')}
      whatsappUrl={WHATSAPP_URL}
      phoneTel={PHONE_TEL}
      onQuoteClick={scrollToContact}
    />

    <CampaignMarquee items={[...marqueeItems, ...marqueeItems]} />

    <CampaignStats stats={numerosStats} ariaLabel="HANSA-FLEX" />

    <CampaignBenefits
      ariaLabel="HANSA-FLEX"
      kicker={t('Why HANSA-FLEX?')}
      title={
        <>
          {t('Advantages that keep')}
          <br />
          {t('your operation running.')}
        </>
      }
      ctaLabel={t('Speak to a specialist.')}
      onCtaClick={scrollToContact}
      cards={beneficiosCards}
    />

    <CampaignServices ariaLabel="HANSA-FLEX" blocks={servicosBlocks} onCtaClick={scrollToContact} />

    <CampaignProducts
      ariaLabel={t('Product Line')}
      kicker={t('Product Line')}
      title={accentLastSegment(t('Hoses for all applications'))}
      cards={produtosCards}
    />

    <CampaignSectors
      ariaLabel={t('Sectors served')}
      kicker={t('Sectors served')}
      title={t('Who we serve')}
      ctaLabel={t('Request a Quote')}
      onCtaClick={scrollToContact}
      cards={segmentosCards}
    />

    <CampaignUrgency
      ariaLabel={t('Emergency care')}
      title={
        <>
          {t('Did the hose burst?')}
          <br />
          {t('Respond immediately.')}
        </>
      }
      paragraph={t(
        'Our team travels with a fully equipped mobile workshop. Every hour of downtime is a loss — contact us now.'
      )}
      whatsappEmergencyUrl={WHATSAPP_EMERGENCY_URL}
      whatsappEmergencyLabel={t('WhatsApp Emergency')}
      callNowLabel={t('Call Now')}
      phoneTel={PHONE_EMERGENCY_TEL}
    />

    <section id="contato" className="hhc-contato" aria-label={t('Request a Quote')}>
      <div className="hhc-ct-grid">
        <div className="hhc-ct-left hhc-reveal hhc-reveal-left">
          <div className="hhc-kicker">{t('Speak to a specialist.')}</div>
          <h2 className="hhc-h-display hhc-ct-h">{accentLastWord(t('Request your quote'))}</h2>
          <p className="hhc-ct-lead">
            {t(
              'We serve São Paulo and the ABC Paulista region with speed and efficiency. Our team responds within 2 hours.'
            )}
          </p>

          <div className="hhc-ct-info">
            <div className="hhc-ct-row">
              <div className="hhc-ct-ic" aria-hidden="true">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.1 1.23 2 2 0 012.1 1h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.91 8.09a16 16 0 006 6l.45-.45a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
              </div>
              <div className="hhc-ct-text">
                <div className="hhc-ct-lbl">{t('Telephone')}</div>
                <a href={PHONE_TEL} className="hhc-ct-val">(11) 95813-9550</a>
              </div>
            </div>
            <div className="hhc-ct-row">
              <div className="hhc-ct-ic" aria-hidden="true">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div className="hhc-ct-text">
                <div className="hhc-ct-lbl">{t('E-mail')}</div>
                <a href="mailto:rogerio.oliveira@hansa-flex.com" className="hhc-ct-val">
                  rogerio.oliveira@hansa-flex.com
                </a>
              </div>
            </div>
            <div className="hhc-ct-row">
              <div className="hhc-ct-ic" aria-hidden="true">
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div className="hhc-ct-text">
                <div className="hhc-ct-lbl">{t('Coverage')}</div>
                <div className="hhc-ct-val">{coverageArea}</div>
              </div>
            </div>
          </div>

          <div className="hhc-ct-btns">
            <a href={WHATSAPP_URL} className="hhc-btn hhc-btn-wa" target="_blank" rel="noopener noreferrer">
              {t('WhatsApp')}
            </a>
            <a href={PHONE_TEL} className="hhc-btn hhc-btn-outline-red">
              {t('To connect')}
            </a>
          </div>
        </div>

        <div className="hhc-ct-right hhc-reveal hhc-reveal-right">
          <div className="hhc-form-box">
            <div className="hhc-form-title">{formQuoteTitle}</div>
            <form
              className="hhc-campaign-form"
              onSubmit={handleSubmit}
              noValidate
              style={{ pointerEvents: isSubmitting ? 'none' : 'auto', opacity: isSubmitting ? 0.7 : 1 }}
            >
              <div className="hhc-f-row">
                <div className="hhc-fg">
                  <label htmlFor="hhc-fullName">{t('Name')}</label>
                  <input
                    id="hhc-fullName"
                    type="text"
                    name="fullName"
                    placeholder={t('John Silva')}
                    value={formData.fullName}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className={errors.fullName ? 'hhc-input-error' : ''}
                    disabled={isSubmitting}
                    autoComplete="name"
                  />
                  {errors.fullName && (
                    <span className="hhc-field-error">{t(errors.fullName)}</span>
                  )}
                </div>

                <div className="hhc-fg">
                  <label htmlFor="hhc-company">{t('Enterprise')}</label>
                  <input
                    id="hhc-company"
                    type="text"
                    name="company"
                    placeholder={t('Limited Company')}
                    value={formData.company}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className={errors.company ? 'hhc-input-error' : ''}
                    disabled={isSubmitting}
                    autoComplete="organization"
                  />
                  {errors.company && (
                    <span className="hhc-field-error">{t(errors.company)}</span>
                  )}
                </div>
              </div>

              <div className="hhc-f-row">
                <div className="hhc-fg">
                  <label htmlFor="hhc-telephone">{t('Phone / WhatsApp')}</label>
                  <input
                    id="hhc-telephone"
                    type="tel"
                    name="telephone"
                    placeholder={t('(11) 99999-9999')}
                    value={formData.telephone}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className={errors.telephone ? 'hhc-input-error' : ''}
                    disabled={isSubmitting}
                    autoComplete="tel"
                  />
                  {errors.telephone && (
                    <span className="hhc-field-error">{t(errors.telephone)}</span>
                  )}
                </div>

                <div className="hhc-fg">
                  <label htmlFor="hhc-email">{t('E-mail')}</label>
                  <input
                    id="hhc-email"
                    type="email"
                    name="email"
                    placeholder={t('joao@empresa.com.br')}
                    value={formData.email}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    className={errors.email ? 'hhc-input-error' : ''}
                    disabled={isSubmitting}
                    autoComplete="email"
                  />
                  {errors.email && (
                    <span className="hhc-field-error">{t(errors.email)}</span>
                  )}
                </div>
              </div>

              <div className="hhc-fg">
                <label htmlFor="hhc-cityState">{t('Segment')}</label>
                <select
                  id="hhc-cityState"
                  name="cityState"
                  value={formData.cityState}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  className={errors.cityState ? 'hhc-input-error' : ''}
                  disabled={isSubmitting}
                >
                  <option value="">{t('Select your segment.')}</option>
                  {segmentosCards.map((segment) => (
                    <option key={segment.name} value={segment.name}>
                      {segment.name}
                    </option>
                  ))}
                </select>
                {errors.cityState && (
                  <span className="hhc-field-error">{t(errors.cityState)}</span>
                )}
              </div>

              <div className="hhc-fg">
                <label htmlFor="hhc-message">{t('Need')}</label>
                <textarea
                  id="hhc-message"
                  name="message"
                  placeholder={t('Briefly describe what you need...')}
                  value={formData.message}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  maxLength={MAX_MESSAGE_LENGTH}
                  className={errors.message ? 'hhc-input-error' : ''}
                  rows="5"
                  disabled={isSubmitting}
                />
                {errors.message && (
                  <span className="hhc-field-error">{t(errors.message)}</span>
                )}
              </div>

              {errors.submit && (
                <div className="hhc-form-alert hhc-form-alert-error">{t(errors.submit)}</div>
              )}
              {submitSuccess && (
                <div className="hhc-form-alert hhc-form-alert-success">
                  {t('Submitted successfully. Please check your email.')}
                </div>
              )}

              <button type="submit" className="hhc-form-submit" disabled={isSubmitting}>
                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                  <line x1="22" y1="2" x2="11" y2="13" />
                  <polygon points="22 2 15 22 11 13 2 9 22 2" />
                </svg>
                {isSubmitting ? t('Sending...') : t('Submit Request')}
              </button>

              <p className="hhc-form-privacy">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
                {t('🔒Your data is confidential.')}
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>

    <div id="sp-abc-whatsapp">
      <WhatsAppChat
        phoneNumber="+55 (11) 95813-9550"
        floatLabel={t('Speak to a specialist.')}
        whatsappMessage="Olá! Gostaria de um orçamento para mangueiras hidráulicas."
        directLink
      />
    </div>
  </CampaignPageLayout>
);
};

export default HydraulicHoseCampaignSPABC;

